import { AccessController } from '@adornis/abac/core/AccessController.js';
import { getRolesForUser, SimpleRolePolicy } from '@adornis/abac/policies/SimpleRolePolicy.js';
import { A } from '@adornis/base/env-info.js';
import { context } from '@adornis/baseql/server/context.js';
import { currentUser } from '@adornis/users/client/currentUser.js';
import { NEXUS_ADMIN_ROLE_NAME } from '@nsc/nexus-permissions/platform-rbac/platform-admin-permissions.js';

async function resolveActingUserId(): Promise<string | undefined> {
  if (A.isServer) {
    return (context as { userID?: string }).userID;
  }
  const user = await currentUser().result;
  return user?._id;
}

export const accessController = new AccessController({
  policies: [
    SimpleRolePolicy,
    {
      name: 'admin context special handling',
      /** Bypass when SimpleRolePolicy denies (e.g. scoped permission); server must not use client `currentUser`. */
      evaluate: async () => {
        const userId = await resolveActingUserId();
        if (!userId) return false;
        const roles = await getRolesForUser(userId)({ roleName: 1 });
        if (roles.some(role => role.roleName === NEXUS_ADMIN_ROLE_NAME)) {
          return { allowed: true, reason: 'Admin' };
        }
        return false;
      },
    },
  ],
});
